/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface GetUserNewsletter$Request {
    userId: number;
}

export interface GetUserNewsletter$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserNewsletterRequest = createAction<PayloadData<void, GetUserNewsletter$Request>>('GET_USER_NEWSLETTER__GET_USER_NEWSLETTER__REQUEST');
export const getUserNewsletterSuccess = createAction<PayloadData<Array<string>, GetUserNewsletter$Request>>('GET_USER_NEWSLETTER__GET_USER_NEWSLETTER__SUCCESS');
export const getUserNewsletterFailure = createAction<PayloadData<Error, GetUserNewsletter$Request, true>>('GET_USER_NEWSLETTER__GET_USER_NEWSLETTER__FAILURE');

export const getUserNewsletterActions = [
    getUserNewsletterRequest,
    getUserNewsletterSuccess,
    getUserNewsletterFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserNewsletter = (meta: GetUserNewsletter$Request, config?: GetUserNewsletter$Config) => {
    return {
        CALL_API: {
            types: getUserNewsletterActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/newsletters`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

